/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, createRef } from "react";
import { createUseStyles } from 'react-jss';
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { getValue, formatDate, b64toBlob } from '../../contexts/Utils';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Button from '@mui/material/Button';
import ButtonGroup from "@mui/material/ButtonGroup";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Checkbox from '@mui/material/Checkbox';
import Autocomplete from '@mui/material/Autocomplete';
import FormHelperText from '@mui/material/FormHelperText';
import DeleteIcon from '@mui/icons-material/Delete';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import IconButton from '@mui/material/IconButton';
import { InputAdornment, Tooltip } from "@mui/material";
import Chip from '@mui/material/Chip';
import CancelIcon from '@mui/icons-material/Cancel';
import { timeStamp } from "../../contexts/Utils";
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import SearchIcon from '@mui/icons-material/Search';
// 
// ─── IMPORTING FONTAWESOME ICONS ───────────────────────────────────────
//
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilterList } from "@fortawesome/pro-duotone-svg-icons";

// 
// ─── TEXTFIELD ───────────────────────────────────────
//
export const Text = (opt) => {

  const field = opt.field;
  const defaultValue = getValue(field, ['default']) || field.value || ''
  const dataSet = {};

  const [value, setValue] = useState(defaultValue)

  const handleChange = (e) => {
    setValue(e.target.value);
    if (field.handleChange) {
      field.handleChange(e.target.value)
    }
  };

  useEffect(() => {
    if (value !== defaultValue) {
      setValue(defaultValue)
    }
  }, [defaultValue])

  Object.entries(field.dataSet || {}).map(([key, value]) => dataSet[key] = value);

  let textField = <TextField
    multiline={field.multiline}
    rows={field.rows || 1}
    maxRows={field.maxRows || 1}
    InputLabelProps={{ shrink: true }}
    label={field.label}
    type={field.type}
    name={field.name}
    value={value}
    onChange={handleChange}
    inputProps={{
      ...dataSet
    }}
    error={field.error ? true : false}
    required={field.required}
    size="small"
    helperText={field.error}
    placeholder={field.placeholder}
    variant={field.variant ? field.variant : 'standard'}
  />
  return textField
}

// 
// ─── SWITCH ───────────────────────────────────────
//
export const SwitchField = (opt) => {

  const field = opt.field
  const defaultValue = getValue(field, ['default']) !== undefined ? getValue(field, ['default']) : field.value || 0
  // 
  // ─── STATE DECLARATION ───────────────────────────────────────
  //
  const [selected, setSelected] = useState(defaultValue)

  useEffect(() => {
    if (defaultValue !== selected) {
      setSelected(defaultValue)
    }
  }, [defaultValue])

  // 
  // ─── INITIALISATION DES STYLES ───────────────────────────────────────
  //
  const useStyle = createUseStyles({
    label: {
      color: 'var(--text-color)'
    }
  })
  const classes = useStyle();

  return (
    <>
      <FormControlLabel
        control={
          <Switch checked={selected ? true : false} value={selected} onChange={() => {
            let value = selected === 0 ? 1 : 0
            setSelected(value)
            if (field.handleChange) {
              field.handleChange(value)
            }
            field.onSelect()
          }} name={field.name} />
        }
        className={classes.label}
        label={field.label || ''}
        disabled={field.disabled}
      />
    </>
  )
}

// 
// ─── RADIO ───────────────────────────────────────
//
export const RadioField = (opt) => {

  const field = opt.field
  const defaultValue = getValue(field, ['default']) !== undefined ? getValue(field, ['default']) : field.value || 0;

  const [value, setValue] = useState(defaultValue);

  const handleChange = (event) => {
    setValue(event.target.value);
    if (field.handleChange) {
      field.handleChange(event.target.value)
    }
  };

  // 
  // ─── INITIALISATION DES STYLES ───────────────────────────────────────
  //
  const useStyle = createUseStyles({
    label: {
      color: 'var(--text-color)'
    }
  })

  const classes = useStyle();

  return <>
    <FormControl>
      <FormLabel id="demo-radio-buttons-group-label">{field.label}</FormLabel>
      <RadioGroup
        row
        aria-labelledby="demo-radio-buttons-group-label"
        value={value}
        name={field.name}
        onChange={handleChange}
      >
        {field.value.map((radio) => (
          <FormControlLabel key={radio.label} value={radio.value} control={<Radio />} label={radio.label} className={classes.label} />
        ))}
      </RadioGroup>
    </FormControl>
  </>
}

// 
// ─── SELECT ───────────────────────────────────────
//
export const SelectField = (opt) => {
  // FONTAWESOME
  library.add(faFilterList)

  const field = opt.field
  const defaults = getValue(field, ['default'])

  // Define the name and value of select items
  const dataLabel = field.dataLabel || 'name';
  const dataValue = field.dataValue || 'id'

  const [select, selectValue] = useState(defaults);

  const handleChange = (event) => {
    selectValue(event.target.value);
    if (field.handleChange) {
      field.handleChange(event.target.value)
    }
  };

  useEffect(() => {
    if (defaults && select !== defaults) {
      selectValue(defaults)
    }
  }, [defaults])

  return field.admin ? <FormControl variant="outlined" size="small">
    <Select
      value={select}
      renderValue={(value) => {
        return <div className='iconSelect text'><FontAwesomeIcon icon={faFilterList} />{value !== 'all' ? field.data.find(brand => brand.id === value).name : 'Toutes'}</div>
      }}
      onChange={handleChange}
      onClick={field.onSelect}
    >
      {field.all ? <MenuItem value='all'>Toutes</MenuItem> : <MenuItem value='-'>Aucune</MenuItem>}
      {field.data && field.data.map((value) => (
        <MenuItem key={value[dataValue]} value={value[dataValue]}>{value[dataLabel]}</MenuItem>
      ))}
    </Select>
  </FormControl> :
    <FormControl variant="outlined" size="small">
      <InputLabel id="simple-select-label" shrink>{field.label}</InputLabel>
      <Select
        value={select}
        input={
          <OutlinedInput
            notched
            name={field.name}
            id="simple-select-label"
            label={field.label}
          />
        }
        onChange={handleChange}
        onClick={field.onSelect}
      >
        {field.none && <MenuItem value='-'>Aucune</MenuItem>}
        {field.data && field.data.map((value) => (
          <MenuItem key={value[dataValue]} value={value[dataValue]}>{value[dataLabel]}</MenuItem>
        ))}
      </Select>
    </FormControl>
}

// 
// ─── SELECT MULTIPLE ───────────────────────────────────────
//
export const SelectMultiple = (opt) => {
  const field = opt.field
  const defaults = getValue(field, ['default'])

  // Define the name and value of select items
  const dataLabel = field.dataLabel || 'name'
  const dataValue = field.dataValue || 'id'

  const [selected, setSelected] = useState([]);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelected(value);
  };

  const handleDelete = (event, value) => {
    setSelected((current) => current.filter((id) => id !== value))
  }

  useEffect(() => {
    if (defaults && defaults.length > 0) setSelected(defaults)
  }, [defaults])

  return selected &&
    <FormControl required={field.required} error={field.error ? true : false} variant="outlined">
      <InputLabel id="mutiple-select-label" shrink>{field.label}</InputLabel>
      <Select
        labelId="mutiple-select-label"
        multiple
        value={selected}
        input={
          <OutlinedInput
            notched
            name={field.name}
            id="mutiple-select"
            label={field.label}
          />
        }
        onChange={handleChange}
        renderValue={selected => (
          <div>
            {selected.map(value => {
              return <Chip
                deleteIcon={<CancelIcon onMouseDown={(event) => event.stopPropagation()} />}
                onDelete={(e) => handleDelete(e, value)}
                key={value.id}
                // "?" permet de retourner undefined si pas de key et donc ne pas casser tout l'app (optionnal chaining)
                label={field.data?.find(e => e.id === value).name}
              />
            })}
          </div>
        )}
      >
        {field.data.map((value) => (
          <MenuItem key={value[dataValue]} value={value.id}>
            <Checkbox checked={selected.includes(value.id)} />
            {value[dataLabel]}
          </MenuItem>
        ))}
      </Select>
      {field.error && <FormHelperText sx={{ marginLeft: 0 }}>{field.error}</FormHelperText>}
    </FormControl>
}
// 
// ─── CHECKBOX ───────────────────────────────────────
//
export const CheckboxField = (opt) => {

  const field = opt.field
  // 
  // ─── STATE DECLARATION ───────────────────────────────────────
  //
  const [checked, setChecked] = useState(field.checked || false)

  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  return <>
    <FormControlLabel control={<Checkbox checked={checked} required={field.required} onChange={handleChange} inputProps={{ 'aria-label': 'controlled' }} name={field.name} />} label={field.label} />
    {field.error && <FormHelperText error={true}>{field.error}</FormHelperText>}
  </>
}

// 
// ─── MULTIPLE ───────────────────────────────────────
//
export const Multiple = (opt) => {
  const field = opt.field
  const fieldName = field.name
  const titles = field.titles
  const defaults = getValue(field, ['default'])

  const componentValue = getValue(field, ['components', 'value'])
  const componentLabel = getValue(field, ['components', 'label'])
  const componentLabelType = getValue(field, ['components', 'label_type'])

  // 
  // ─── CHAMPS NECESSAIRES ───────────────────────────────────────
  //
  let multipleFields = {}

  if (defaults) {
    Object.values(JSON.parse(defaults)).forEach((el, index) => {
      const elementId = `${field.name}_${index}`
      multipleFields[elementId] = [
        { type: componentLabelType, component: componentLabel, label: titles.label, value: el.label, name: `${field.name}_label_${index}` },
        { type: "text", component: componentValue, label: titles.value, value: el.value, name: `${field.name}_value_${index}`, multiline: field.multiline, hidden: field.hidden }
      ]
    })
  } else {
    multipleFields = {
      1: [
        { type: componentLabelType, component: componentLabel, label: titles.label, name: `${fieldName}_label_1` },
        { type: "text", component: componentValue, label: titles.value, name: `${fieldName}_value_1`, multiline: field.multiline, hidden: field.hidden }
      ]
    }
  }

  // 
  // ─── STATE DECLARATION ───────────────────────────────────────
  //
  const [fields, setFields] = useState(multipleFields)

  // 
  // ─── INITIALISATION DES STYLES ───────────────────────────────────────
  //
  const useStyle = createUseStyles({
    multipleContainer: {
      display: 'flex',
      flexDirection: 'column'
    },
    multipleLabel: {
      display: 'flex',
      '& > span': {
        width: '50%'
      }
    },
    multipleFields: {
      display: 'flex',
      marginTop: 20,
    },
    button: {
      marginTop: "20px !important"
    },
    inputLeft: {
      marginLeft: 5
    },
    inputRight: {
      marginRight: 5
    },
    label: {
      color: 'var(--text-color)'
    }
  })

  const classes = useStyle();

  return (
    <div>
      <label className={classes.label}>{field.label}</label>
      <div className={classes.multipleContainer + ' form__multiple'}>
        {Object.values(fields).map((element, index) => {
          return <div key={index} className={classes.multipleFields}>
            {
              element.map((el, i) => {
                return <Formfields key={i} field={{ ...el, ...{ dataSet: { 'data-attribute': 'multiple', 'data-name': fieldName } } }} classNameOuter={i === 0 ? classes.inputRight : classes.inputLeft} />
              })
            }
          </div>
        })}
      </div>
      {!field.removeAdd && <Button className={classes.button} variant="contained" onClick={(event) => {
        event.preventDefault();
        let index = Object.keys(fields).length + 1;

        // 
        // ─── AJOUT D'UN ELEMENT SUPPLEMENTAIRE A LA LISTE ───────────────────────────────────────
        //
        setFields(fields[index] = {
          ...fields,
          [`${field.name}_${index}`]: [
            { type: componentLabelType, component: componentLabel, label: titles.label, name: `${fieldName}_label_${index}` },
            { type: "text", component: componentValue, label: titles.value, name: `${fieldName}_value_${index}`, multiline: field.multiline, hidden: field.hidden }
          ]
        })
      }}>Ajouter</Button>}
    </div>
  )
}

// 
// ─── UPLOAD FILE ───────────────────────────────────────
//
export const UploadFile = (opt) => {
  const field = opt.field;
  const [file, setFile] = useState(field.default || field.fileName || '')
  const [preview, setPreview] = useState(field.link ? `${process.env.REACT_APP_URL}/img/${field.link}?${timeStamp()}` : '')
  const [imageError, setImageError] = useState('')

  // CROPPING
  const [cropping, setCropping] = useState(false)
  const [cropData, setCropData] = useState(null);
  const cropperRef = createRef();

  // 
  // ─── INITIALISATION DES STYLES ───────────────────────────────────────
  //
  let useStyle = createUseStyles({
    input: { display: "none !important" },
    label: {
      marginBottom: 10,
      display: 'block',
      color: 'var(--text-color)',
    },
    error: {
      color: '#d32f2f',
      marginTop: 5,
      display: 'block'
    },
    field: {
      width: '100%',
      border: field.error ? '1px solid #d32f2f !important' : 'initial'
    },
    fileUploaded: {
      width: 'calc(50% - 10px)',
      alignItems: 'center'
    },
    fileContent: {
      display: 'flex',
      flexDirection: 'column',
      marginRight: 'auto',

      '& button': {
        marginTop: 10
      }
    },
    filePreview: {
      width: '100%',
      margin: '10px 0',
    },
    fileIcon: {
      fontSize: '35px !important',
      color: 'var(--primary-color)'
    },
    fileLabel: {
      marginBottom: 5
    },
    fileName: {
      fontSize: 13,
      width: 275,
      textOverflow: 'ellipsis',
      overflow: 'hidden'
    },
    imageAndDelete: {
      display: 'flex',
      alignItems: 'flex-end',
      gap: 10,

      '& .deleteImg': {
        marginBottom: 0
      }
    }
  })

  const classes = useStyle();

  useEffect(() => {
    if (field.crop && field.afterCrop && cropData) {
      const newPic = b64toBlob(cropData)
      // On renvoit le fichier avec le nom de l'image
      field.afterCrop(newPic, file)
    }
  }, [cropData])

  const handleChange = (e) => {
    let image = e.target.files[0]
    if (image.size < 10000000) {
      let img = URL.createObjectURL(image)
      setCropData(null)
      setPreview(img)
      setFile(image.name)
      if (field.handleChange) {
        field.handleChange(e)
      }
      setCropping(true)
    } else {
      setImageError('Image trop lourde, veuillez en sélectionner une autre.')
    }
  }

  const getCropData = () => {
    if (typeof cropperRef.current?.cropper !== "undefined") {
      setCropData(cropperRef.current?.cropper.getCroppedCanvas().toDataURL());
    }
  };

  const handleCrop = (e) => {
    e.preventDefault();
    if (cropping) getCropData();
    setCropping(!cropping);
  }

  return <>
    <span className={classes.label}>{opt.field.label}</span>
    <div className={classes.fileUploaded} style={{ display: file ? 'flex' : 'none', }}>
      <div className={classes.fileContent}>
        <span className={classes.fileName}>{file}</span>
        <div className={classes.imageAndDelete}>
          {field.crop && <>
            {!cropping && <img id="previewImg" className={classes.filePreview} src={cropData ? cropData : preview} alt="profile" />}
            {cropping && <Cropper
              ref={cropperRef}
              initialAspectRatio={1}
              preview=".img-preview"
              src={preview}
              viewMode={1}
              minCropBoxHeight={10}
              minCropBoxWidth={10}
              background={false}
              responsive={true}
              autoCropArea={1}
              checkOrientation={false}
              guides={true}
            />}
          </>}
          {!field.crop &&
            <img loading="lazy" id="previewImg" className={classes.filePreview} src={preview} alt="your image" />
          }
          <div className="deleteImg" aria-label="delete" onClick={() => {
            document.querySelector(`input[name='${field.name}']`).value = '';
            setFile(null);
            if (field.handleRemove) {
              field.handleRemove({ name: field.name, filename: field.default })
            }
          }}>
            <Tooltip title='Supprimer'>
              <IconButton
                aria-label="delete"
                onClick={() => {
                  document.querySelector(`input[name='${field.name}']`).value = '';
                  setFile(null);
                }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          </div>
        </div>
        {field.crop && <Button variant="contained" onClick={handleCrop}>{cropping ? 'Valider' : 'Rogner'}</Button>}
      </div>
    </div>
    <div className={classes.fileContainer} style={{ display: file ? 'none' : 'block' }}>
      <label htmlFor={`${field.name}-file`} className={classes.label}>
        <Input className={classes.input} inputProps={{ accept: 'image/png, image/jpg' }} id={`${field.name}-file`} type="file" name={field.name} onChange={(e) => { handleChange(e) }} required={field.required ? true : false} />
        <Button variant="contained" component="span" className={classes.field}>Télécharger</Button>
        {(field.error || imageError) && <span className={classes.error}>{imageError || field.error}</span>}
      </label>
    </div>
  </>
}

// 
// ─── DATE AND TIME PICKER ───────────────────────────────────────
//
const DatePicker = (props) => {
  let field = props.field;

  let defaultDate = field.default;
  const dataSet = {};

  if (field.isoDefault || (field.filled && field.default)) {
    defaultDate = field.default
  } else {
    defaultDate = formatDate({ time: field.default, display: 'datetimepicker' }) || null
  }

  Object.entries(field.dataSet || {}).map(([key, value]) => dataSet[key] = value);

  const [date, setDate] = useState(defaultDate);
  var now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());

  // RESET VALUE INPUT ON RESET BAR ADMIN
  if (field.reset && date) {
    defaultDate = ''
    setDate(defaultDate)
  }

  return <TextField
    className={field.className}
    label={field.label}
    type={field.type}
    size="small"
    value={field.value || date}
    defaultValue={field.filled ? now.toISOString().slice(0, 16) : field.default || ''}
    name={field.name}
    required={field.required}
    error={field.error ? true : false}
    helperText={field.error}
    variant='standard'
    inputProps={{
      ...dataSet
    }}
    onChange={(e) => {
      setDate(e.target.value)
      if (field.handleChange) {
        field.handleChange(e.target.value)
      }
    }}
    InputLabelProps={{
      shrink: true,
    }}
    InputProps={{
      disableUnderline: field.admin ? true : false,
      startAdornment: (field.admin && field.start) && (
        <InputAdornment position="start">
          <CalendarTodayIcon />
        </InputAdornment>
      ),
    }}
  />

}

// 
// ─── BUTTON GROUP ───────────────────────────────────────
//
const GroupedButtons = (opt) => {
  const field = opt.field;
  const [counter, setCounter] = useState(1);

  // 
  // ─── INITIALISATION DES STYLES ───────────────────────────────────────
  //
  const useStyle = createUseStyles({
    label: {
      marginRight: 10,
    }
  })

  const classes = useStyle();

  // 
  // ─── HANDLE INPUT INCREMENTATION OR DECREMENT ───────────────────────────────────────
  //
  const handleIncrement = () => {
    setCounter(counter + 1);
  };

  const handleDecrement = () => {
    setCounter(counter - 1);
  };
  return (
    <div>
      <span className={classes.label}>{field.label}</span>
      <ButtonGroup size="small" aria-label="small outlined button group">
        <Button disabled={counter === 1} onClick={handleDecrement}>-</Button>
        <TextField
          size="small"
          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
          name={field.name}
          value={counter} onChange={(e) => {
            const value = parseInt(e.target.value);
            if (value <= 8) {
              setCounter(parseInt(e.target.value))
            }
          }}
          style={{ width: 40 }}
        />
        <Button disabled={counter === 8} onClick={handleIncrement}>+</Button>
      </ButtonGroup>
    </div>
  );
}
//
// ─── GENERATION DES CHAMPS ───────────────────────────────────────
//
const SearchField = (props) => {
  const field = props.field;
  const data = field.data;

  const [value, setValue] = useState('');

  useEffect(() => {
    if (field.default !== value) {
      setValue(field.default || '')
    }
    if (field.default) {
      const defaultUser = field.data.find(e => e.user_id === field.default)
      setValue(defaultUser || '')
    }
  }, [field.default])

  return <>
    <Autocomplete
      id={props.name}
      size="small"
      freeSolo
      multiple={field.multiple}
      options={data}
      noOptionsText={'Aucun résultat'}
      getOptionLabel={(option) => option.name + ' ' + option.firstname || option || ''}
      onChange={(e, inputValue) => {
        field.handleChange && field.handleChange(inputValue ? inputValue.user_id : '')
        setValue(inputValue)
      }}
      defaultValue={value ? value[0] : null}
      className={props.className}
      renderInput={(params) =>
        <TextField
          {...params}
          InputLabelProps={{ shrink: true }}
          label={field.label}
          value='test'
          placeholder={field.placeholder}
        />
      }
    />
    {value && <input type='hidden' name={field.name} value={value.user_id} />}
  </>
}

// 
// ─── GENERATION DES CHAMPS ───────────────────────────────────────
//
const Formfields = (props) => {
  let fields

  switch (props.field.component) {
    case "select_multiple":
      fields = SelectMultiple(props)
      break;
    case "switch":
      fields = SwitchField(props)
      break;
    case "radio":
      fields = RadioField(props)
      break;
    case "select":
      fields = SelectField(props)
      break;
    case "checkbox":
      fields = CheckboxField(props)
      break;
    case "multiple":
      fields = Multiple(props)
      break;
    case "file":
      fields = UploadFile(props)
      break;
    case "datepicker":
      fields = DatePicker(props);
      break;
    case "grouped_btn":
      fields = GroupedButtons(props);
      break;
    case "search":
      fields = SearchField(props);
      break;
    default:
      fields = Text(props)
      break;
  }

  // 
  // ─── INITIALISATION DES STYLES ───────────────────────────────────────
  //
  const useStyle = createUseStyles({
    inputContainer: {
      display: props.field.hidden ? 'none' : "flex",
      flexDirection: "column",
      "@media screen and (max-width:780px)": {
        width: '100% !important'
      }
    }
  })

  const classes = useStyle();

  return <div className={classes.inputContainer + ' formfield_container ' + props.classNameOuter} style={{ width: props.field.size || props.field.component !== 'color' ? props.field.size : '100%' }}>
    {fields}
  </div>
}

export default Formfields